module.exports = __webpack_public_path__ + "img/ph-3-dub.7e646729.jpg";